import defaultConfig from "../config/partners/default"

export const partnerConfig = (_, vendorData = {}) =>
  defaultConfig({ brandName: vendorData?.name })
